import { Repository } from '../../../core/context/repository';
import { type ThreatVectorMitigationTask } from './entity';

export class ThreatVectorMitigationTasks extends Repository<ThreatVectorMitigationTask> {
    getByThreatVectorMitigationId(
        threatVectorMitigationId: string,
    ): ThreatVectorMitigationTask[] {
        return this.items.filter(
            (entity) =>
                entity.threatVectorMitigationId === threatVectorMitigationId,
        );
    }
}
